import { Col, Row } from "antd";
import { useMobileAppVersionContext } from "../../../context/MobileAppVersionContext/MobileAppVersionContext";
import SwitchOptionComponent from "../../../components/SwitchComponent";
import { useEffect, useState } from "react";

const ForceUpdateSettings = () => {
	const { versionData, versionDetail, setVersionData } = useMobileAppVersionContext();
	const [forceUpdate, setForceUpdate] = useState<boolean | undefined>(versionDetail?.forceUpdate);

	useEffect(() => {
		setForceUpdate(versionDetail?.forceUpdate);
	}, [versionDetail?.forceUpdate])
	return (
		<>
			<Row gutter={20}>
				<Col span={10}>
					<SwitchOptionComponent
						title="Force Update"
						value={forceUpdate}
						onChange={(checked) => {
							setForceUpdate(checked);
							setVersionData({...versionData, forceUpdate: checked });
						}}
						helperText="Bu ayar etkinleştirildiğinde, kullanıcılar uygulamayı güncellemek için zorunlu olacaktır."
					/>
				</Col>
			</Row>
		</>
	);
};

export default ForceUpdateSettings;
